import ItemsGrid from './itemsGrid'

export default ItemsGrid
